import request from '@/utils/request';

export function flowSubmit(mavinEid) {
    return request({
        url: `/position/mavin/flow/submit/${mavinEid}`,
        method: 'put'
    });
}

export function flowAudit(mavinEid) {
    return request({
        url: `/position/mavin/flow/audit/${mavinEid}`,
        method: 'put'
    });
}

export function flowInf(auditType, mavinEid) {
    return request({
        url: `/position/mavin/flow/${auditType}/${mavinEid}`,
        method: 'get'
    });
}

export function flowBack(mavinEid, data) {
    return request({
        url: `/position/mavin/flow/back/${mavinEid}`,
        method: 'post',
        data: data
    });
}

export function flowReset(mavinEid) {
    return request({
        url: `/position/mavin/flow/reset/${mavinEid}`,
        method: 'post'
    });
}